import { render, staticRenderFns } from "./AINotebook.vue?vue&type=template&id=70daae49&lang=pug"
import script from "./AINotebook.vue?vue&type=script&lang=js"
export * from "./AINotebook.vue?vue&type=script&lang=js"
import style0 from "./AINotebook.vue?vue&type=style&index=0&id=70daae49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports